import React from "react"

import styled from "styled-components/native"

import Column from "./column"

const InnerContainer = styled.View<{ $maxWidth?: number }>`
  width: 100%;
  max-width: ${(props) => props.$maxWidth ?? props.theme.maxPageWidth}px;
`

export default function CenteredContent({
  children,
  maxWidth,
  paddingHorizontal = "pagePaddingHorizontal",
  ...columnProps
}: Parameters<typeof Column>[0] & { maxWidth?: number }): React.JSX.Element {
  return (
    <Column width="100%" paddingHorizontal={paddingHorizontal} {...columnProps}>
      <InnerContainer $maxWidth={maxWidth}>{children}</InnerContainer>
    </Column>
  )
}
